import React, { Component } from "react";
import Predefine_Colar_Basketball from "../components/Predefine_Colar_Basketball/Predefine_Colar_Basketball";

export class Predefine_Colar_BasketballPage extends Component {
  render() {
    return <Predefine_Colar_Basketball />;
  }
}

export default Predefine_Colar_BasketballPage;
